export default __webpack_public_path__ + "static/mo-link-email-gif-4b592821dad330a75af87b8f67524edc.mp4";